<kl-grid
  [columns]="[
    { header: 'code' | translate, binding: 'code', visible: true },
    {
      header: 'description' | translate,
      binding: 'description',
      size: '*',
      visible: true
    },
    {
      header: 'master_unit' | translate,
      binding: 'master_unit.description',
      size: '*',
      visible: true
    }
  ]"
  definition="Birimler"
  [mode]="'DIALOG'"
  [closeInside]="true"
  [filterable]="true"
  [modalClass]="'modal-dialog modal-lg'"
  [filterSelectItems]="filterSelectItems"
  [deferResizing]="false"
  [tabId]="tabId || modalId"
  [service]="{
    service: 'unitSet',
    name: 'unit_set',
    form: 'UNITSET',
    showButton: true,
    showDropDownButton: true
  }"
  [parentModuleName]="'MATERIAL_MANAGEMENT'"
  [moduleName]="'UNIT_SET_LIST'"
  [gridName]="'grdUnitSetList'"
>
</kl-grid>
